// extracted by mini-css-extract-plugin
export default {"grade":"GradeBl_grade__1r0lq"};